var lib_core      = require("lib-core");
var lib_geometry  = require("lib-geometry");


var YHandleModel = require("./YHandleModel.js");
var YHandleView = require("./YHandleView.js");

var Editor3d = require("./../../editor3d/editor3dController.js");

var YHandleController = function(archLayers, dependencies, options) {
    lib_core.Controller.call(this, archLayers, dependencies, options);
};
lib_core.inherit(YHandleController, lib_core.Controller);
YHandleController.inject = {
    editor3d : Editor3d
};

module.exports = YHandleController;

YHandleController.prototype.handleId = "moveY";

YHandleController.prototype.createModel = function () {
    var editor3dModel = this.editor3d.getModel();

    return new YHandleModel(editor3dModel, this.handleId, this.configuration);
};


YHandleController.prototype.createView = function () {
    var editor3dView = this.editor3d.getView();

    return new YHandleView(this.getModel(), editor3dView, this.handleId, this.configuration);
};



